import React from 'react';
import { Cities } from 'btdt-types';
import { IExploreFilters } from './types';
import venuesDataProvider from '../data/venuesDataProvider';
import { IExploreVenue } from '../types';
import { useParams } from 'react-router-dom';

const resolveInitialFilters = (): IExploreFilters => {
  const randomYear = Math.floor(Math.random() * 10) + 2005;

  const params = new URLSearchParams(window.location.search);
  const paramCity = params.get('city');

  let city: Cities;
  if (paramCity && (paramCity === Cities.HAIFA || paramCity === Cities.TLV)) {
    city = paramCity;
  } else {
    const savedCity = localStorage.getItem('city');
    if (savedCity && (savedCity === Cities.HAIFA || savedCity === Cities.TLV)) {
      city = savedCity;
    } else {
      city = Cities.TLV;
    }
  }

  return {
    city,
    yearRange: { from: randomYear, to: randomYear },
    tags: [],
  }
}

export interface IUseExploreResult {
  filters: IExploreFilters;
  applyFilters(filters: Partial<IExploreFilters>): void;
  venues: IExploreVenue[];
}

const useExplore = (): IUseExploreResult => {
  const { id } = useParams();

  const [filters, setFilters] = React.useState<IExploreFilters>(resolveInitialFilters());

  const { venues } = venuesDataProvider.useSearchVenuesQuery(filters, id ? parseInt(id) : null, { includeOutsideDateRange: true });

  const applyFilters = (newFilters: Partial<IExploreFilters>): void => {
    setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    if (newFilters.city) {
      localStorage.setItem('city', newFilters.city);
    }
  }

  return {
    filters,
    applyFilters,
    venues: (venues || []) as IExploreVenue[],
  };
};

export default useExplore;
